import { Tooltip } from "antd/lib";
import {
  FacebookIcon,
  FacebookShareButton,
  RedditIcon,
  RedditShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterShareButton,
} from "next-share";
import { FaIcon } from "./faIcon";

interface SocialShareProps {
  url: string;
  title?: string;
  description?: string;
  hashtags?: string[];
  direction?: "row" | "column";
  className?: string;
}

const SocialShare = ({
  url,
  title = "",
  description = "",
  hashtags = [],
  direction = "row",
  className,
}: SocialShareProps) => (
  <div className={`flex gap-2 ${direction === "row" ? "flex-row" : "flex-col"} ${className}`}>
    <Tooltip title="Share on Telegram">
      <TelegramShareButton url={url} title={title}>
        <TelegramIcon size={24} round />
      </TelegramShareButton>
    </Tooltip>

    <Tooltip title="Share on Facebook">
      <FacebookShareButton url={url} quote={description} hashtag={hashtags.length > 0 ? `#${hashtags[0]}` : undefined}>
        <FacebookIcon size={24} round />
      </FacebookShareButton>
    </Tooltip>

    <Tooltip title="Share on Reddit">
      <RedditShareButton url={url} title={title}>
        <RedditIcon size={24} round />
      </RedditShareButton>
    </Tooltip>

    <Tooltip title="Share on Twitter">
      <TwitterShareButton url={url} title={title} hashtags={hashtags}>
        <FaIcon className="size-6 text-[#1D9BF0]" name="twitter" />
      </TwitterShareButton>
    </Tooltip>
  </div>
);

export default SocialShare;
